import React from "react";

import noResultsFound from "/asset/image/noResultsFound.png";
import EmptyStateCta from "/component/partial/EmptyStateCta";
import { useTranslation } from "/hook";
import { layout } from "/styles";

const IMAGE_HEIGHT = 261;
const IMAGE_WIDTH = 183;

const DocumentsEmptyState = () => {
  const { t } = useTranslation("documents");

  return (
    <div css={layout.flexVerticalCenter}>
      <div css={layout.marginVertical(60)}>
        <EmptyStateCta
          imageHeight={IMAGE_HEIGHT}
          imageWidth={IMAGE_WIDTH}
          imageSource={noResultsFound}
          title={t("emptyState.title")}
          subtitle={t("emptyState.visitDocs.subtitle")}
        />
      </div>
    </div>
  );
};

export default DocumentsEmptyState;
